export default import.meta.ROLLDOWN_FILE_URL_w_MVTf00LzUtBfx4jokTTg